import cn from 'classnames'
import { useOutsideClick } from '../../core/hooks'

import { ReactComponent as ArrowIcon } from './assets/images/arrow.svg'

import c from './assets/sass/form.module.scss'

const Select = ({ title, value, isOpened, onToggle, children }) => {
    const ref = useOutsideClick(() => {
        if (isOpened) {
            onToggle()
        }
    }, isOpened)

    return (
        <div
            className={cn(c.select, {
                [c.opened]: isOpened,
            })}
            ref={ref}
        >
            <div className={c.selectCurrentBlock} onClick={onToggle}>
                <ArrowIcon className={c.arrow} />
                <div className={c.selectCurrent}>
                    <div className={c.selectCurrentTitle}>{title}</div>
                    <div className={c.selectCurrentSubtitle}>{value}</div>
                </div>
            </div>

            <div className={c.selectRow}>
                <div className={c.listWrapper}>{children}</div>
            </div>
        </div>
    )
}

export default Select
